import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import Dialog from 'components/Dialog';
// Components
import Video from 'components/Video';

type Props = {
  onClose: () => void;
}

const BrandVideoDialog:FC<Props> = ({ onClose }) => {
  const quiz = useAppSelector(selectQuiz);

  return (
    <Dialog classes="p-4">
      <div className="flex-1 flex items-center">
        <div className="shadow-primary rounded-lg overflow-hidden">
          <Video
            videoUrl={quiz?.brandVideo}
            onEndedCallback={onClose}
          />
        </div>
      </div>
    </Dialog>
  )
}

export default BrandVideoDialog;
